const normalizeModuleKey = (value) =>
  String(value || "")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "");

export const MODULE_ROUTE_DEFINITIONS = Object.freeze([
  { path: "/Dashboard", aliases: ["Dashboard"] },
  { path: "/CallCenterInterface", aliases: ["Call Center", "Call Center Interface"] },
  { path: "/Von-HubInterface", aliases: ["Von-Hub Interface", "Von Hub Interface", "Vonage Hub"] },
  { path: "/CustomerSearch", aliases: ["Customer Search"] },
  { path: "/CallsInfo", aliases: ["Calls", "Calls Info", "Vonage Calls Info"] },
  { path: "/LocationsInfo", aliases: ["Locations", "Locations Info"] },
  { path: "/QueueSetup", aliases: ["Queue Setup", "Routing Queues"] },
  { path: "/HubSpotInfo", aliases: ["HubSpot Email", "HubSpot Info", "HubSpot Emails Info"] },
  { path: "/UsersSetup", aliases: ["Users Setup", "People Setup"] },
  { path: "/AccessSetup", aliases: ["Access Setup", "Roles and Access"] },
  { path: "/AgentsSetup", aliases: ["Agents Setup", "Routing Agents"] },
  { path: "/CatalogSetup", aliases: ["Catalog Setup", "CRM Catalog Setup"] },
  { path: "/CustomerInfo360", aliases: ["Customer 360", "Customer Info 360"] },
  { path: "/UnifiedCRM", aliases: ["Unified CRM"] },
  { path: "/EmailTickets", aliases: ["Email Tickets"] },
  { path: "/OperationalPlaybooks", aliases: ["Operational Playbooks", "Service Playbooks", "Guided Operations"] },
  { path: "/Reports", aliases: ["Reports", "Report Center", "Reporting"] },
  { path: "/QualityAssurance", aliases: ["Quality Assurance", "Quality Workspace", "QA Workspace"] },
  { path: "/ActionCenter", aliases: ["Action Center", "Alerts", "Workspace Alerts"] },
  { path: "/AutomationStudio", aliases: ["Automation Studio", "Governed Automation", "Automation"] },
  { path: "/Audit", aliases: ["Audit", "Audit Trail", "Operational Audit"] },
  { path: "/HubSpotArchive", aliases: ["HubSpot Archive"] },
  { path: "/AccountSetup", aliases: ["Account Setup", "Account Control Center"] },
]);

const routeByModuleKey = new Map();
const canonicalRouteByLowerPath = new Map();

MODULE_ROUTE_DEFINITIONS.forEach((definition) => {
  canonicalRouteByLowerPath.set(definition.path.toLowerCase(), definition.path);
  definition.aliases.forEach((alias) => {
    routeByModuleKey.set(normalizeModuleKey(alias), definition.path);
  });
  routeByModuleKey.set(normalizeModuleKey(definition.path), definition.path);
});

const routeFromCandidate = (candidateRoute) => {
  const clean = String(candidateRoute || "").trim();
  if (!clean) return "";

  const direct = canonicalRouteByLowerPath.get(clean.toLowerCase());
  if (direct) return direct;

  // Older servers emitted /CallCenter/<ModuleName>. Resolve those links without
  // allowing an arbitrary API value to become a browser navigation target.
  const legacyMatch = clean.match(/^\/CallCenter\/([^/?#]+)\/?$/i);
  if (!legacyMatch) return "";

  let legacyName = legacyMatch[1];
  try {
    legacyName = decodeURIComponent(legacyName);
  } catch {
    // The undecoded value can still match a safe source-controlled alias.
  }
  return routeByModuleKey.get(normalizeModuleKey(legacyName)) || "";
};

/**
 * Resolve module metadata to a source-controlled application route.
 * Unknown API routes are rejected instead of falling through to Dashboard.
 */
export function resolveModuleRoute(moduleName, candidateRoute = "") {
  const namedRoute = routeByModuleKey.get(normalizeModuleKey(moduleName));
  return namedRoute || routeFromCandidate(candidateRoute);
}

export function isRegisteredModuleRoute(path) {
  return canonicalRouteByLowerPath.has(String(path || "").trim().toLowerCase());
}
